import { IconStar, IconUserCheck, IconUsers } from '@tabler/icons-react';
import type { PersonStanding } from '../../shared/contracts';
import { classNames } from '../classNames';

const STANDINGS: Record<
  PersonStanding,
  { label: string; Icon: typeof IconStar; tone: string }
> = {
  staff: {
    label: 'Staff',
    Icon: IconStar,
    tone: 'border-standing-staff/50 bg-standing-staff/10 text-standing-staff',
  },
  member: {
    label: 'Member',
    Icon: IconUserCheck,
    tone: 'border-standing-member/50 bg-standing-member/10 text-standing-member',
  },
  public: {
    label: 'Public',
    Icon: IconUsers,
    tone: 'border-standing-public/50 bg-standing-public/10 text-standing-public',
  },
};

export function StandingBadge({ standing }: { standing: PersonStanding }) {
  const { label, Icon, tone } = STANDINGS[standing];
  return (
    <span
      className={classNames(
        'flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-sm font-medium whitespace-nowrap',
        tone,
      )}
    >
      <Icon size={18} aria-hidden />
      <span className="max-sm:sr-only">{label}</span>
    </span>
  );
}
